import showView from "../views/index";

const loggedIn = () => {
    showView('NAV');    
}

export default loggedIn;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/loggedIn.js